import { NodeWithMultipleHandles } from '../NodeWithMultipleHandles';

export function CliALXNode(props) {
    return <NodeWithMultipleHandles {...props} nodeType="cli_a_lx" />;
}
